import { Column, Entity, Index } from 'typeorm';
import { BaseEntity } from './base.entity';

/**
 * PD-14261 — Phase 2 port-in: one row per NUMBER inside a port-in request
 * (mirrors the Twilio Port-In phone-number child resource). Carries the
 * per-number status + rejection detail (codes 22150–22159 mapped to friendly
 * copy in the UI). `fk_softphone_number__id` is set later — when the number is
 * pre-staged (Phase 3) or activated on cutover (Phase 5) — linking it to the
 * tenant's `softphone_number` row in the same DB.
 */
@Index('port_in_number_sid_idx', ['portInPhoneNumberSid'], { unique: true })
@Index('port_in_number_request_idx', ['fkPortInRequestId'])
@Entity('port_in_number')
export class PortInNumberEntity extends BaseEntity {
	/** Owning port-in request. */
	@Column('int', { name: 'fk_port_in_request__id', unsigned: true })
	public fkPortInRequestId!: number;

	/** Twilio Port-In phone-number SID (child). Unique. `TEST_PIN_…` in test mode. */
	@Column('varchar', { name: 'portInPhoneNumberSid', length: 64 })
	public portInPhoneNumberSid!: string;

	/** The number being ported, E.164. */
	@Column('varchar', { name: 'phoneE164', length: 32 })
	public phoneE164!: string;

	/** waiting_for_signature | submitted | pending | completed | rejected | canceled */
	@Column('varchar', { name: 'status', length: 32, default: 'submitted' })
	public status!: string;

	/** Twilio rejection reason code (e.g. 22153) when status = rejected. */
	@Column('varchar', { name: 'rejectionReasonCode', length: 8, nullable: true })
	public rejectionReasonCode!: string | null;

	/** Twilio's verbatim rejection text (we map the code to friendly copy in the UI). */
	@Column('text', { name: 'rejectionReasonText', nullable: true })
	public rejectionReasonText!: string | null;

	/**
	 * The tenant `softphone_number` this port number is wired to. NULL until
	 * the number is pre-staged (Phase 3) or activated on cutover (Phase 5).
	 */
	@Column('int', {
		name: 'fk_softphone_number__id',
		unsigned: true,
		nullable: true,
	})
	public fkSoftphoneNumberId!: number | null;
}
